// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const TaskAttachmentDetailsEditorContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-taskattachmentdetailseditorcontainer" */ "./TaskAttachmentDetailsEditorContainer")).then((bundle)=>{
        return {
            default: bundle.TaskAttachmentDetailsEditorContainer
        };
    });
export const LazyTaskAttachmentDetailsEditorContainer = /*#__PURE__*/ lazy(TaskAttachmentDetailsEditorContainerLazyLoader);
